import { translate } from '@gig/magic-common';
import { mailCheck } from '@gig/magic-account-types';
import { ValidationDisplay, required, isEmail } from '@gig/magic-form-builder';

function email(fieldConfig) {
    return {
        id: 'email',
        serverId: 'email',
        component: 'magic-ui-form-field',
        isDataField: true,
        testId: 'step1-email',
        properties: {
            'type': 'email',
            'placeholder': translate('sign-up-step-one.email.placeholder'),
            'suggestion-message': translate('sign-up-step-one.email.suggestion-message'),
        },
        dynamicProperties: {
            'has-suggestion': hasEmailSuggestion(fieldConfig),
            'suggestion': suggestedEmail(fieldConfig),
        },
        emitHandlers: {
            'apply-suggestion': function ($event) {
                var suggestion = $event.detail[0];
                return { id: 'email', value: suggestion };
            },
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-one.email.error'),
            },
            {
                name: 'email',
                fn: isEmail,
                message: translate('sign-up-step-one.email.error'),
            },
        ],
    };
}
function suggestedEmail(fieldConfig) {
    return function (data) {
        if (!fieldConfig.mailCheck || !data.email.isValid) {
            return '';
        }
        var email = mailCheck(data.email.value, fieldConfig.mailCheckConfig);
        return email !== false ? email.full : '';
    };
}
function hasEmailSuggestion(fieldConfig) {
    var suggestionForConfig = suggestedEmail(fieldConfig);
    return function (data) {
        var suggestedEmail = suggestionForConfig(data);
        return suggestedEmail !== '' && suggestedEmail !== data.email.value;
    };
}

export { email };
